angular.module('tenantBilling')
    .filter('orDash', function() {
        return function(value) {
            if (_.isUndefined(value) || _.isNull(value) || _.isEmpty(value)) return "-"
            return value;
        }
    });